"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformDriversCompanyStatusToString = transformDriversCompanyStatusToString;
const legacy_enums_1 = require("@daytrip/legacy-enums");
function transformDriversCompanyStatusToString(status) {
    switch (status) {
        case legacy_enums_1.DriversCompanyStatus.Active:
            return "active";
        case legacy_enums_1.DriversCompanyStatus.Declined:
            return "declined";
        case legacy_enums_1.DriversCompanyStatus.Hired:
            return "hired";
        case legacy_enums_1.DriversCompanyStatus.Lead:
            return "lead";
        default:
            return "unknown";
    }
}
//# sourceMappingURL=transformDriversCompanyStatusToString.js.map